import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Pagination } from "@mui/material";
import UserService from "../services/user-service";
import AuthService from "../services/auth";
import Popup from "reactjs-popup";
import IUPopup from "../components/updateIncomePop";
import IRPopup from "../components/removeIncomePop";
import { ReactComponent as EditPic } from "../assets/editpencil.svg";
import { ReactComponent as RemovePic } from "../assets/redfilltrash.svg";
import { useHistory } from "react-router-dom";
import { ArrowContainer } from "react-tiny-popover";
import { ReactComponent as CloseIcon } from "../assets/cross.svg";
import cs from "classnames";
import CustomButton from "./UI/CustomButton/inedx";
import PopoverView from "./UI/PopoverView";
import { useSelector } from "react-redux";
import { themModeSelector } from "../redux/selectors/AuthSelectors";
import moment from "moment";
import "reactjs-popup/dist/index.css";
import "../styling/landingtable.css";

const fontStyle = "ProximaNova-Bold-03 !important";
const fontSize = "20px !important";

var formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

function createData(name, revenue, expenses, source, note, sales) {
  return { name, revenue, expenses, source, note, sales };
}

const rows = [
  createData("Name", "100", "100", "source", "note1", "100"),
  createData("Name 2", "200", "200", "source2", "note2", "200"),
];

export default function LandingData({
  filterType,
  activeModalStep,
  handleClose,
  reloadTableDataAPI,
  setReloadTableDataAPI
}) {
  const { isDarkMode } = useSelector(themModeSelector);
  const bgColor = isDarkMode ? "#2e2e2e" : "#fbfbfb";
  const textColor = isDarkMode ? "#fbfbfb" : "#2e2e2e";
  const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
    action: {
      margin: 5,
      padding: 5,
      backgroundColor: bgColor,
    },
    tableHead: {
      fontSize: fontSize,
      height: 58,
      backgroundColor: "#f3f0f0",
      color: textColor,
      fontFamily: fontStyle,
    },
    tableDataExpense: {
      color: "#000000",
      backgroundColor: bgColor,
    },
    tableDataRevenue: {
      color: "#000000",
      backgroundColor: bgColor,
    },
    tableDataName: {
      fontWeight: 700,
      backgroundColor: bgColor,
    },
    tableDataNote: {
      backgroundColor: bgColor,
      color: "#A3A3A3",
    },
    tableProfitData: {
      backgroundColor: bgColor,
      color: "green",
    },
    tableDataAction: {
      backgroundColor: bgColor,
    },
  });

  const history = useHistory();
  const [isLoading, setLoading] = useState(true);
  const [nrows, setnRows] = useState(rows);
  const [, setAlldata] = useState({});
  const classes = useStyles();

  const [page, setPage] = useState(1);
  const rowsPerPage = 20;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  function componentMounted() {
    const currUser = AuthService.getCurrentUser();
    if (!currUser) {
      history.push("/auth/login");
    }
  }
  componentMounted();

  function getTotalExpenses(data, info, filterType) {
    const temp = {};
    const totalAmount: number[] = [];
    const max = info.source.length;
    for (let i = 1; i <= max; i++) {
      temp[i] = 0;
    }

    switch (filterType) {
      case 0:
        data.forEach(function (a) {
          if (temp.hasOwnProperty(a.incomeStream)) {
            temp[a.incomeStream] = temp[a.incomeStream] + a.amount;
          } else {
            temp[a.incomeStream] = a.amount;
          }
        });
        break;
      case 1:
        var weeknumber: any = [
          moment().subtract(8, "days"),
          moment().subtract(1, "days"),
        ];

        const filterByWeek = data.filter((data) =>
          moment(data.date).isBetween(weeknumber[0]._d, weeknumber[1]._d)
        );
        filterByWeek.forEach(function (a) {
          if (temp.hasOwnProperty(a.incomeStream)) {
            temp[a.incomeStream] = temp[a.incomeStream] + a.amount;
          } else {
            temp[a.incomeStream] = a.amount;
          }
        });
        break;
      case 2:
        const filterByMonth = data.filter(
          (data) => new Date(data.date).getMonth() === new Date().getMonth()
        );
        filterByMonth.forEach(function (a) {
          if (temp.hasOwnProperty(a.incomeStream)) {
            temp[a.incomeStream] = temp[a.incomeStream] + a.amount;
          } else {
            temp[a.incomeStream] = a.amount;
          }
        });
        break;
      case 3:
        const filterByYear = data.filter(
          (data) =>
            new Date(data.date).getFullYear() === new Date().getFullYear()
        );
        filterByYear.forEach(function (a) {
          if (temp.hasOwnProperty(a.incomeStream)) {
            temp[a.incomeStream] = temp[a.incomeStream] + a.amount;
          } else {
            temp[a.incomeStream] = a.amount;
          }
        });
        break;
      default:
        return null;
    }
    for (var item in temp) {
      totalAmount.push(temp[item]);
    }
    return totalAmount;
  }

  function getTotalSales(data, info, filterType) {
    const temp = {};
    const totalSales: number[] = [];
    const max = info.source.length;
    for (let i = 1; i <= max; i++) {
      temp[i] = 0;
    }
    switch (filterType) {
      case 0:
        data.forEach(function (a) {
          if (temp.hasOwnProperty(a.incomeStream)) {
            temp[a.incomeStream] = temp[a.incomeStream] + a.amount;
          } else {
            temp[a.incomeStream] = a.amount;
          }
        });
        break;
      case 1:
        var weeknumber: any = [
          moment().subtract(8, "days"),
          moment().subtract(1, "days"),
        ];
        const filterByWeek = data.filter((data) =>
          moment(data.date).isBetween(weeknumber[0]._d, weeknumber[1]._d)
        );
        filterByWeek.forEach(function (a) {
          if (temp.hasOwnProperty(a.incomeStream)) {
            temp[a.incomeStream] = temp[a.incomeStream] + a.amount;
          } else {
            temp[a.incomeStream] = a.amount;
          }
        });
        break;
      case 2:
        const filterByMonth = data.filter(
          (data) => new Date(data.date).getMonth() === new Date().getMonth()
        );
        filterByMonth.forEach(function (a) {
          if (temp.hasOwnProperty(a.incomeStream)) {
            temp[a.incomeStream] = temp[a.incomeStream] + a.amount;
          } else {
            temp[a.incomeStream] = a.amount;
          }
        });
        break;
      case 3:
        const filterByYear = data.filter(
          (data) =>
            new Date(data.date).getFullYear() === new Date().getFullYear()
        );
        filterByYear.forEach(function (a) {
          if (temp.hasOwnProperty(a.incomeStream)) {
            temp[a.incomeStream] = temp[a.incomeStream] + a.amount;
          } else {
            temp[a.incomeStream] = a.amount;
          }
        });
        break;
      default:
        return null;
    }

    for (var item in temp) {
      totalSales.push(temp[item]);
    }
    return totalSales;
  }

  useEffect(() => {
    UserService.getIncome().then((response) => {
      const data = response.data;
      setAlldata(data);
      UserService.getExpense().then((response) => {
        const expenses = getTotalExpenses(
          response.data.expense,
          data,
          filterType
        );
        UserService.getSale().then((response) => {
          const sales = getTotalSales(response.data.sale, data, filterType);
          const dataArray = UserService.makeIncomeArray(
            data.iname,
            data.source,
            data.income,
            data.note,
            expenses,
            sales
          );
          dataArray.forEach((item) => {
            item.sales = item.sales.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            item.expenses = item.expenses.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          });
          setnRows(dataArray);
          setLoading(false);
        });
      });
    });
  }, [filterType, reloadTableDataAPI]);

  if (isLoading) {
    return (
      <TableContainer component={Paper}>
        <Table></Table>
      </TableContainer>
    );
  }
const handleStream=(data)=>{  
  sessionStorage.setItem("bussinessStream", data.name)
  sessionStorage.setItem("option", "expense")
}

  return (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell className={classes.tableHead}>Name</TableCell>
              <TableCell align="left" className={classes.tableHead}>
                Profit
              </TableCell>
              <TableCell align="left" className={classes.tableHead}>
                Revenue
              </TableCell>
              <TableCell align="left" className={classes.tableHead}>
                Expenses
              </TableCell>
              <TableCell align="left" className={classes.tableHead}>
                Notes
              </TableCell>
              <TableCell align="left" className={classes.tableHead}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {nrows.length > 0 &&
              nrows
                .slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)
                .map((nrow, index) => (
                  <TableRow key={index}>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tableDataName}
                      id={index === 0 ? "active-cell" : ""}
                    >
                      {index === 0 ? (
                        <PopoverView
                          isOpen={activeModalStep === "3"}
                          positions={["right"]}
                          parentElement={document.getElementById("active-cell")}
                          content={({
                            position,
                            targetRect,
                            childRect,
                            popoverRect,
                          }) => (
                            <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                              position={position}
                              popoverRect={popoverRect}
                              arrowColor={"#41c175"}
                              arrowSize={20}
                              arrowStyle={{ opacity: 0.7 }}
                              childRect={childRect}
                              arrowClassName="arrow-wrapper-right"
                            >
                              <div className="position-relative popover-wrapper">
                                <div className="d-flex justify-content-end">
                                  <CloseIcon
                                    className={cs("closeIcon")}
                                    style={{ fill: "#fff" }}
                                    onClick={handleClose}
                                  />
                                </div>
                                <div className="">
                                  Click on your income stream to learn about
                                  more features.
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="dot-list-wrapper">
                                    {[1, 2, 3, 4, 5, 6].map((list, index) => (
                                      <div
                                        key={index}
                                        className={cs("dots", {
                                          ["active-dots"]:
                                            list <= +activeModalStep,
                                        })}
                                      />
                                    ))}
                                  </div>

                                  <CustomButton
                                    className="start-btn mt-0 mb-0"
                                    onClick={() => {
                                      localStorage.setItem("hintStep", "4");
                                      history.push(`/stream/${nrow.name}`);
                                    }}
                                  >
                                    Next
                                  </CustomButton>
                                </div>
                              </div>
                            </ArrowContainer>
                          )}
                        >
                          <Link
                            className="d-flex align-items-center"
                            to={{
                              pathname: "/stream/" + nrow.name,
                              state: { stream: index },
                            }}
                          >
                            <div className="upload-image mr-2">
                              <h3 className="text-center">
                                {nrow.name.charAt(0)}
                              </h3>
                            </div>
                            <div className="tablelink">
                              {nrow.name} {">"}
                            </div>
                          </Link>
                        </PopoverView>
                      ) : (
                        <Link
                          className="d-flex align-items-center"
                          to={{
                            pathname: "/stream/" + nrow.name,
                            state: { stream: index },
                          }}
                          onClick={()=>{handleStream(nrow)}}
                        >
                          <div className="upload-image mr-2">
                            <h3 className="text-center">
                              {nrow.name.charAt(0)}
                            </h3>
                          </div>
                          <div className="tablelink">
                            {nrow.name} {">"}
                          </div>
                        </Link>
                      )}
                      <div className="source">{nrow.source}</div>
                    </TableCell>
                    <TableCell
                      align="left"
                      component="th"
                      scope="row"
                      className={classes.tableProfitData}
                    >
                      {parseFloat(nrow.sales.replace(/,/g, "")) -
                        parseFloat(nrow.expenses.replace(/,/g, "")) <
                      0
                        ? "-" +
                          formatter.format(
                            Math.abs(
                              parseFloat(nrow.sales.replace(/,/g, "")) -
                                parseFloat(nrow.expenses.replace(/,/g, ""))
                            )
                          )
                        : formatter.format(
                            parseFloat(nrow.sales.replace(/,/g, "")) -
                              parseFloat(nrow.expenses.replace(/,/g, ""))
                          )}
                    </TableCell>
                    <TableCell
                      align="left"
                      component="th"
                      scope="row"
                      className={classes.tableDataRevenue}
                    >
                      ${nrow.sales}
                    </TableCell>
                    <TableCell
                      align="left"
                      className={classes.tableDataExpense}
                    >
                      ${nrow.expenses}
                    </TableCell>
                    <TableCell
                      align="left"
                      component="th"
                      scope="row"
                      className={classes.tableDataNote}
                    >
                      {nrow.note}
                    </TableCell>

                    <TableCell align="left" className={classes.tableDataAction}>
                      <Popup
                        trigger={
                          <button className="actionbuttonE">
                            <EditPic stroke="grey" />
                          </button>
                        }
                        modal
                        nested
                      >
                        {(close) => (
                          <div className="mode">
                            <button className="close" onClick={close}>
                              &times;
                            </button>
                            <div className="header"> Update Income </div>
                            <div className="content">
                              <IUPopup
                                keydata={nrow}
                                stream={index}
                                closeUpdateIncome={close}
                                setReloadTableData={setReloadTableDataAPI}
                              ></IUPopup>
                              <br />
                            </div>
                          </div>
                        )}
                      </Popup>
                      <Popup
                        trigger={
                          <button className="actionbutton removebuttonE">
                            <RemovePic />
                          </button>
                        }
                        modal
                        nested
                      >
                        {(close) => (
                          <div className="mode">
                            <button className="close" onClick={close}>
                              &times;
                            </button>
                            <div className="header"> Remove Income Source </div>
                            <div className="content">
                              <IRPopup
                                keydata={nrow}
                                stream={index}
                                closeRemoveIncome={close}
                                setReloadTableData={setReloadTableDataAPI}
                              ></IRPopup>
                              <br />
                            </div>
                          </div>
                        )}
                      </Popup>
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>
    <div className="d-flex align-items-center justify-content-between mt-5">
      <p className="rows-perpage-text">Showing rows {(page-1)*rowsPerPage+1} to {Math.min(page*rowsPerPage,nrows.length)} of {nrows.length}</p>
      <Pagination
        count={Math.ceil(nrows.length / rowsPerPage)}
        variant="outlined"
        shape="rounded"
        page={page}
        onChange={handleChangePage}
      />
    </div>
    </>
  );
}
